var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.provider)?_c(_vm.buttonComponent,_vm._g(_vm._b({tag:"component",staticClass:"btn-social-auth-button",on:{"click":function($event){$event.preventDefault();return _vm.onClick(_vm.provider)}}},'component',_vm.componentAttrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }